<template>
		<div class="">
      <div class="">
          <div class="nav" style="margin-top:30px;">
            <span class="">{{$t('DailyLogin')}}</span>
          </div>
          <div class="mission-h ">
            <div style="font-size: 22px;" class="" v-html="$t('DailyLoginT1')"></div>
          </div>
          <div class="daily-login-list mt20" style="text-align: center">
            <div class="daily-li" v-for="(item,index) in dailyList" :class="{'active':item.status==0,'dailyd12':item.status==3}" @click="getMissed(item)">
              <div class="num">{{item.sign_day}}</div>
              <div class="img">
                <img :src="item.image" />
              </div>
              <div class="t">{{item.title}}</div>
              <div class="Missed disflex" v-if="item.status==2"><img height="50" src="../../static/images/miss.png">{{$t('Missed')}}</div>
              <div class="dailyd disflex" v-if="item.status==1"><img src="../../static/images/dailyd.png"></div>
              <div class="dailyd dailyd2 disflex" v-if="item.status==3"></div>
            </div>
          </div>
          <div class="mt20 ac" style="">
            <button class="btn-yl font-family fw7" @click="getClaim()">{{$t('Claim')}}</button>
          </div>
      </div>
      <Dialog ref="answerDialog" type="alert" :callback="answerModal" title="" width="100" :modalFoot="false">
          <div class="" slot="mdBox" >
            <div class="answer-modal daily-modal">
              <div style="width:90%;margin:0 auto">
                <div class="">
                  <div class="fs50 font-family dui">{{$t('ReClaim')}}</div>
                  <img class="big-img" :src="info.image" />
                  <div class="daliy-t">
                    {{info.tip}}
                  </div>
                  <div class="answer-t2">
                    <div class="fw7">{{$t('DailyLoginT2')}}</div>
                    {{$t('DailyLoginT3')}}
                  </div>
                  <button class="btn6 font-family mt20" style="width: 280px;line-height: 103px;color: #fff;font-size: 30px;" @click="cancelModal">{{$t('cancel')}}</button>
                  <button style="width: 280px;height: 104px;" class="btn-yl font-family mt20" @click="answerModal">{{$t('yesClaim')}}</button>
                </div>
              </div>
            </div>
          </div>
      </Dialog>
		</div>
</template>
<script>
import Dialog from './dialog'
export default {
  props: {
      message: {
        type: String,   // 类型校验
        default: '默认值' // 默认值（可选）
      },
  },
  components:{
  Dialog
  },
  data() {
    return {
      info:{},
      dailyList:[],
      parent:null
    }
  },
  created(){
    if(this.message=='2'){
      this.parent = this.$parent.$parent
    }else{
        this.parent = this.$parent.$parent.$parent
    }
    this.getHome();
  },
  methods: {
		back(){
			this.$router.push({path:'/'})
		},
    answerModal(){
      let that = this;
      that.parent.loadModal(true);
      that.$api.post('/api/sign/buy_sign_card',null,r =>{
        if(r.msg) that.$utils.alertText(r.msg);
        that.parent.returnCode(r,function(){
            that.parent.loadModal(false);
            if (r.code == 1){
              that.getClaim(that.info)
            }else {
              that.$utils.alertText(r.msg, 80);
            }
        });
      })
    },
    getMissed(item){
      if(item.status!=2){
        if(item.status==0){
          this.getClaim()
        }else{
          this.$utils.alertText(item.tips2);
        }
        return;
      }
      this.info = item
      this.$refs.answerDialog.showMaskFun();
    },
    cancelModal(){
      this.$refs.answerDialog.closeMask();
    },
		getHome(){
			let that =this;
      console.log(that.parent.$parent.$parent)
			that.parent.loadModal(true);
			that.$api.get('/api/sign/get_sign',null,r =>{
				that.parent.returnCode(r,function(){
          that.parent.loadModal(false);
          that.dailyList = r.data.sign_data
        });

			})
		},
    getClaim(item){
      let that = this;
      let data = null
      if(item){
         data = {
          sign_date:item.sign_date,
          is_repair:1
        }
      }
			that.parent.loadModal(true);
      that.$api.post('/api/sign/signin',data,r =>{
        if(r.msg) that.$utils.alertText(r.msg);
      	that.parent.returnCode(r,function(){
          that.parent.loadModal(false);
          that.getHome()
          that.$emit("child-event", true);
          that.$refs.answerDialog.closeMask();
        });

      })
    }
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/dailyLogin.vue